import { GetObjectCommand, PutObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { getSignedUrl as s3GetSignedUrl } from '@aws-sdk/s3-request-presigner';
import { Readable } from 'stream';

export interface SignedUrlParams {
    Bucket: string;
    Key: string;
    Expires?: number;
}

export interface StoreDocumentOptions {
    bucket: string;
    filename: string;
    body: Buffer;
    contentType: string;
}

const client = new S3Client({
    apiVersion: '2006-03-01',
    region: process.env.AWS_REGION,
});

export const getSignedUrl = async (
    operation: string = 'getObject',
    { Bucket, Key, Expires = 3600 }: SignedUrlParams
) => {
    if (operation === 'getObject') {
        return await s3GetSignedUrl(
            client,
            new GetObjectCommand({ Bucket, Key, ResponseContentDisposition: 'attachment' }),
            { expiresIn: Expires }
        );
    }

    return await s3GetSignedUrl(client, new PutObjectCommand({ Bucket, Key }), {
        expiresIn: Expires,
    });
};

export const storeDocument = async (options: StoreDocumentOptions) => {
    const command = new PutObjectCommand({
        Body: options.body,
        Bucket: options.bucket,
        Key: options.filename,
        ContentDisposition: 'inline',
        ContentType: options.contentType,
    });
    return client.send(command);
};

export const getDocument = async (bucket: string, key: string) => {
    const data = await client.send(
        new GetObjectCommand({
            Bucket: bucket,
            Key: key,
        })
    );

    const body = await streamToBuffer(data.Body as Readable);
    return {
        ...data,
        Body: body,
    };
};

const streamToBuffer = async (stream: Readable): Promise<Buffer> => {
    const chunks: Buffer[] = [];
    for await (const chunk of stream) {
        chunks.push(typeof chunk === 'string' ? Buffer.from(chunk) : chunk);
    }
    return Buffer.concat(chunks);
};
